import {
  NetworkIdSchema
} from "./chunk-3RJE5RUH.mjs";

// src/logs/logs.ts
import { z } from "zod";
var LogSchema = z.object({
  id: z.string().min(1),
  appId: z.string(),
  appName: z.string(),
  network: NetworkIdSchema.optional(),
  method: z.string(),
  duration: z.number(),
  fcu: z.number(),
  numRequestsInBatch: z.number(),
  requestBody: z.string(),
  requestBodyIsValid: z.boolean(),
  requestUriParams: z.string(),
  responseBody: z.string(),
  responseBodyIsValid: z.boolean(),
  responseErrorCode: z.number(),
  responseHttpStatusCode: z.number(),
  sentAt: z.string().datetime()
});

export {
  LogSchema
};
//# sourceMappingURL=chunk-74M3K2Y6.mjs.map